export const RAF_STARTED_AT = "RAF_STARTED"; // Refer a friend started on this date.
